import { EntityExtensions } from "@common/ADAPT.Common.Model/entity-extensions.decorator";
import { CulturalActivityExtensions } from "@common/ADAPT.Common.Model/organisation/cultural-activity-extensions";
import { CulturalActivitySupplementaryData } from "@common/ADAPT.Common.Model/organisation/cultural-activity-supplementary-data";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { CulturalActivityType } from "./cultural-activity-type";
import { Organisation } from "./organisation";
import { Team } from "./team";

export class CulturalActivity extends BaseEntity<CulturalActivity> {
    public culturalActivityId!: number;
    public organisationId!: number;
    public type!: CulturalActivityType;
    public entityId?: number;
    public date!: Date;
    public initialDate!: Date;
    public teamId?: number;
    public person1Id?: number;
    public person2Id?: number;
    public isCompleted!: boolean;

    @EntityExtensions(CulturalActivityExtensions)
    public extensions!: CulturalActivityExtensions;

    public organisation!: Organisation;
    public team?: Team;
    public person1?: Person;
    public person2?: Person;
    public supplementaryData?: CulturalActivitySupplementaryData;
}

export const CulturalActivityBreezeModel = new BreezeModelBuilder("CulturalActivity", CulturalActivity)
    .hasSource()
    .withPluralName("Cultural Activities")
    .withActivePath("person1.connections")
    .withActivePath("person2.connections")
    .isOrganisationEntity()
    .build();
